import { Avatar } from '@rivallapp/native-base';

export default Avatar;
